import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import useAxiosConfig from "../config/useAxiosConfig";

export default function useExportXCSI() {
  const { loading: axiosLoading, error } = useAxiosConfig();

  const exportXCSI = async () => {
    try {
      // GET the export data from the Taffy API
      const resp = await axios.get("/CcpExportXCSI");

      // The CF component returns a structure with 'rows' (array) or the array directly
      const data = resp.data;
      let rows = [];
      if (Array.isArray(data)) rows = data;
      else if (data && Array.isArray(data.rows)) rows = data.rows;
      else if (data && data.result && Array.isArray(data.result))
        rows = data.result;

      // Fallback empty
      rows = rows || [];

      // Convert to worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "XCSI");

      // Write workbook to binary array
      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      // Create blob and trigger download
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const filename = `XCSI_${new Date().toISOString().slice(0, 10)}.xlsx`;
      saveAs(blob, filename);

      return { success: true, rowsCount: rows.length };
    } catch (err) {
      console.error("exportXCSI error:", err);
      throw err;
    }
  };

  return { exportXCSI, axiosLoading, error };
}
